import type { MouseEvent } from "react";
import { useTranslation } from "react-i18next";
import type { SectionKey } from "../../../types/clientConfig";
import Modal from "../../modal-new";

const sectionsEmojis = {
  training: "🏋️",
  nutrition: "🥗",
  mealPlans: "📋",
  dailyAccountabilities: "✅",
  goals: "🎯",
};

interface TemplateConflictModalProps {
  isVisible: boolean;
  conflictingSections: SectionKey[];
  onConfirm: () => void;
  onCancel: () => void;
}

export const TemplateConflictModal = ({
  isVisible,
  conflictingSections,
  onConfirm,
  onCancel,
}: TemplateConflictModalProps) => {
  const { t } = useTranslation(["athlete-portal", "common"]);

  if (!isVisible) return null;

  const handleOverlayClose = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    onCancel();
  };

  return (
    <Modal
      className="template-conflict-modal"
      title={t("clientConfiguration.templateConflictModal.title")}
      onClose={handleOverlayClose}
    >
      <div className="body">
        <p>{t("clientConfiguration.templateConflictModal.body")}</p>
        <ul>
          {conflictingSections.map((section) => (
            <li key={section}>
              <span>{sectionsEmojis[section]} </span>
              <span>{t(`clientConfiguration.sections.${section}`)}</span>
            </li>
          ))}
        </ul>
        <p className="chip warning">
          {t("clientConfiguration.templateConflictModal.footer")}
        </p>
      </div>
      <footer className="client-config-footer-buttons">
        <div className="right-content">
          <button type="button" data-button-type="secondary" onClick={onCancel}>
            {t("common:cancel")}
          </button>
          <button type="button" data-button-type="primary" onClick={onConfirm}>
            {t("clientConfiguration.templateConflictModal.confirm")}
          </button>
        </div>
      </footer>
    </Modal>
  );
};
